export default {
    DEFAULT: {
        value: 'DEFAULT',
        transKey: 'DROPDOWN.DEFAULT',
    },
    DATE_ENTRY_ASC: {
        value: 'DATE_ENTRY_ASC',
        transKey: 'DROPDOWN.DATE_ENTRY_ASC',
    },
    DATE_ENTRY_DESC: {
        value: 'DATE_ENTRY_DESC',
        transKey: 'DROPDOWN.DATE_ENTRY_DESC',
    },
    ODOMETER_ASC: {
        value: 'ODOMETER_ASC',
        transKey: 'DROPDOWN.ODOMETER_ASC',
    },
    ODOMETER_DESC: {
        value: 'ODOMETER_DESC',
        transKey: 'DROPDOWN.ODOMETER_DESC',
    },
    SALE_PRICE_ASC: {
        value: 'SALE_PRICE_ASC',
        transKey: 'DROPDOWN.PRICE_ASC',
    },
    SALE_PRICE_DESC: {
        value: 'SALE_PRICE_DESC',
        transKey: 'DROPDOWN.PRICE_DESC',
    },
    YEAR_ASC: {
        value: 'YEAR_ASC',
        transKey: 'DROPDOWN.YEAR_ASC',
    },
    YEAR_DESC: {
        value: 'YEAR_DESC',
        transKey: 'DROPDOWN.YEAR_DESC',
    },
    MODEL_NAME_RAW_ASC: {
        value: 'MODEL_NAME_RAW_ASC',
        transKey: 'DROPDOWN.MODEL_NAME_RAW_ASC',
    },
    MODEL_NAME_RAW_DESC: {
        value: 'MODEL_NAME_RAW_DESC',
        transKey: 'DROPDOWN.MODEL_NAME_RAW_DESC',
    },
    FEATURED_ASC: {
        value: 'FEATURED_ASC',
        transKey: 'DROPDOWN.FEATURED_ASC',
    },
    FEATURED_DESC: {
        value: 'FEATURED_DESC',
        transKey: 'DROPDOWN.FEATURED_DESC',
    },
};
